export default __webpack_public_path__ + "static/media/TPTV Leaderboard 2.4faa71a9.png";